import { render, staticRenderFns } from "./storeOrderCartReturn.vue?vue&type=template&id=3b4d1800&scoped=true"
import script from "./storeOrderCartReturn.vue?vue&type=script&lang=js"
export * from "./storeOrderCartReturn.vue?vue&type=script&lang=js"
import style0 from "./storeOrderCartReturn.vue?vue&type=style&index=0&id=3b4d1800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d1800",
  null
  
)

export default component.exports